import { keyToUrl } from '@tools/common'

export const companiesKeys = {
  root: ['companies'] as const,
  company: (id: number) => [...companiesKeys.root, id] as const,
  companyPreferences: (companyExternalId: string) =>
    [...companiesKeys.root, 'preferences', companyExternalId] as const,
  companyPartners: (id: number) =>
    [...companiesKeys.company(id), 'partners'] as const,
  companyPartner: (companyId: number, partnerId: number) => [
    ...companiesKeys.companyPartners(companyId),
    partnerId,
  ],
}

export const companiesUrls = {
  root: keyToUrl(companiesKeys.root),
  company: (id: number) => keyToUrl(companiesKeys.company(id)),
  companyPreferences: (companyExternalId: string) =>
    keyToUrl(companiesKeys.companyPreferences(companyExternalId)),
  companyPartners: (id: number) => keyToUrl(companiesKeys.companyPartners(id)),
  companyPartner: (companyId: number, partnerId: number) =>
    keyToUrl(companiesKeys.companyPartner(companyId, partnerId)),
}
